import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAuthToken, getUserData } from '../utils/authUtils';
import { useAuth } from '../context/AuthContext'; // Import the useAuth hook

const ProtectedRoute = ({ children }) => {
  const token = getAuthToken();
  if (!token ) {
    // Redirect to login if there's no token or user -> !user
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;